import React from 'react';

import { submit, isInvalid } from 'redux-form';

import styles from './troy.module.scss';

import { connectTo } from '../../utils';
import {
  beginPaymentSession,
  beginMollieSession,
  beginIdealInstallmentSession,
  payOffline,
  getUser,
  sendCalculatorInfo,
  paySepaDirectDebit,
  setPaymentMethod,
  payLater,
  payMollieSofort,
} from '../../actions';

import { RadioGroup, Translation } from '../../components/common';
import InstallmentContent from '../../components/common/InstallmentContent/index.troy';
import {
  SepaDirectDebit,
  Sepa as SepaContent,
  PaymentNow,
  IDEALInstallment,
  PayLater,
} from '../../components/payments/index.troy';

import {
  IDEAL_MOLLIE_VALUE,
  IDEAL_INSTALLMENT_VALUE,
  IDEAL_INSTALLMENT_FORM_NAME,
  OFFLINE_SEPA_VALUE,
  INSTALLMENT_VALUE,
  INSTALLMENT_FORM_NAME,
  SEPA_DIRECT_DEBIT_VALUE,
  SEPA_DIRECT_DEBIT_FORM_NAME,
  PAY_NOW_TEXT_KEY,
  PAY_LATER_VALUE,
  PAY_LATER_FORM_NAME,
  SOFORT_MOLLIE_VALUE,
  CREDIT_CARD_MOLLIE_VALUE,
  PAYPAL_MOLLIE_VALUE,
} from '../../constants/payment';
import { PAYMENT_REDIRECT } from '../../constants/routes';

import { filterPaymentMethods } from '../../utils/payment';
import {
  getUrlParams,
  getSearchQuery,
  getSearchUrl,
} from '../../utils/httpUtil';

const imagedPaymentMethods = (paymentMethods) =>
  paymentMethods.map(({ label, image, value, displayName, id }) => ({
    label: (
      <div className={styles['payments__card']}>
        <img
          className={styles['payments__card-image']}
          src={image}
          alt="card"
        />
        {label ? (
          <Translation className={styles['payments__card-label']}>
            {label}
          </Translation>
        ) : null}
      </div>
    ),
    value,
    content: null,
    displayName,
    id: 'page.payments.component.payment-radiogroup.' + id,
  }));

const transformPaymentMethods = (
  paymentMethods,
  {
    username,
    currency,
    balance,
    firstName,
    lastName,
    email,
    mobilePhone,
    phone,
    sendCalculatorInfo,
    beginIdealInstallmentSession,
    paySepaDirectDebit,
    payLater,
  }
) => {
  paymentMethods = imagedPaymentMethods(paymentMethods);
  paymentMethods = filterPaymentMethods(paymentMethods, { balance });

  const offlineSepaInd = paymentMethods.indexOf(
    paymentMethods.find(({ value }) => value === OFFLINE_SEPA_VALUE)
  );
  if (offlineSepaInd >= 0) {
    paymentMethods[offlineSepaInd].content = (
      <SepaContent username={username} />
    );
  }

  const installmentInd = paymentMethods.indexOf(
    paymentMethods.find(({ value }) => value === INSTALLMENT_VALUE)
  );
  if (installmentInd >= 0) {
    paymentMethods[installmentInd].content = (
      <InstallmentContent
        {...{
          currency,
          balance,
          firstName,
          lastName,
          email,
          mobilePhone,
          phone,
          onSubmit: (values) => {
            sendCalculatorInfo({ currency, ...values });
          },
        }}
        pageName="payments"
      />
    );
  }

  const directDebitInd = paymentMethods.indexOf(
    paymentMethods.find(({ value }) => value === SEPA_DIRECT_DEBIT_VALUE)
  );
  if (directDebitInd >= 0) {
    paymentMethods[directDebitInd].content = (
      <SepaDirectDebit
        {...{
          firstName,
          lastName,
          onSubmit: (values) => {
            paySepaDirectDebit(values);
          },
        }}
      />
    );
  }

  const idealInstallmentInd = paymentMethods.indexOf(
    paymentMethods.find(({ value }) => value === IDEAL_INSTALLMENT_VALUE)
  );
  if (idealInstallmentInd >= 0) {
    paymentMethods[idealInstallmentInd].content = (
      <IDEALInstallment
        {...{
          currency,
          balance,
          email,
          mobilePhone,
          phone,
          onSubmit: (values) => {
            beginIdealInstallmentSession({
              currency,
              ...values,
            });
          },
        }}
      />
    );
  }

  const payLaterInd = paymentMethods.indexOf(
    paymentMethods.find(({ value }) => value === PAY_LATER_VALUE)
  );
  if (payLaterInd >= 0) {
    paymentMethods[payLaterInd].content = (
      <PayLater
        {...{
          currency,
          balance,
          email,
          mobilePhone,
          phone,
          onSubmit: (values) => {
            payLater(values);
          },
        }}
      />
    );
  }

  return paymentMethods;
};

class Payments extends React.Component {
  constructor(props) {
    super(props);
    const { history, location } = props;
    const { method, ...params } = getUrlParams();

    this.state = {
      methodName: '',
      methodValue: method || null,
      paymentMethods: [],
    };

    history.replace(getSearchUrl({ url: location.pathname, query: params }));
  }

  componentDidMount() {
    const { getUser, username } = this.props;

    if (!username) {
      getUser();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      username,
      paymentMethods,
      hide,
      currency,
      balance,
      firstName,
      lastName,
      email,
      mobilePhone,
      phone,
      sendCalculatorInfo,
      beginMollieSession,
      beginIdealInstallmentSession,
      paySepaDirectDebit,
      payLater,
    } = nextProps;

    if (paymentMethods && paymentMethods.length) {
      const transformed = transformPaymentMethods(paymentMethods, {
        username,
        currency,
        balance,
        firstName,
        lastName,
        email,
        mobilePhone,
        phone,
        sendCalculatorInfo,
        beginMollieSession,
        beginIdealInstallmentSession,
        paySepaDirectDebit,
        payLater,
      });
      const newState = {
        paymentMethods: hide ? transformed.slice(0, 1) : transformed,
      };

      if (hide) {
        newState.methodName = transformed[0].displayName;
        newState.methodValue = transformed[0].value;
      } else if (prevState.methodValue) {
        const selectedMethod = transformed.find(
          ({ value }) => value === prevState.methodValue
        );
        if (selectedMethod) {
          newState.methodName = selectedMethod.displayName;
        }
      }

      return newState;
    }

    return null;
  }

  onCardChange = ({ target: { value } }) => {
    const displayName = this.state.paymentMethods.find(
      (method) => method.value === value
    ).displayName;
    this.setState({
      methodName: displayName,
      methodValue: value,
    });
  };

  onPayNow = () => {
    const {
      balance,
      currency,
      history,
      submit,
      setPaymentMethod,
      beginPaymentSession,
      beginMollieSession,
    } = this.props;
    const { methodValue } = this.state;
    if (balance > 0) {
      switch (methodValue) {
        case OFFLINE_SEPA_VALUE: {
          setPaymentMethod(OFFLINE_SEPA_VALUE);
          history.push(PAYMENT_REDIRECT + '?status=success');
          break;
        }
        case INSTALLMENT_VALUE: {
          submit(INSTALLMENT_FORM_NAME);
          break;
        }
        case SEPA_DIRECT_DEBIT_VALUE: {
          submit(SEPA_DIRECT_DEBIT_FORM_NAME);
          break;
        }
        case IDEAL_INSTALLMENT_VALUE: {
          submit(IDEAL_INSTALLMENT_FORM_NAME);
          break;
        }
        case PAY_LATER_VALUE: {
          submit(PAY_LATER_FORM_NAME);
          break;
        }
        case IDEAL_MOLLIE_VALUE:
        case SOFORT_MOLLIE_VALUE:
        case CREDIT_CARD_MOLLIE_VALUE:
        case PAYPAL_MOLLIE_VALUE: {
          beginMollieSession({
            amount: balance,
            currency,
            type: methodValue,
          });
          break;
        }
        default: {
          beginPaymentSession({
            type: methodValue,
            amount: balance,
            currency: currency,
          });
          break;
        }
      }
    }
  };

  render() {
    const { methodName, methodValue, paymentMethods } = this.state;
    const {
      token,
      isInvalidInstallment,
      isInvalidIdealInstallment,
      isInvalidPayLater,
      isInvalidSepaDirectDebit,
      translations,
      balance,
      paymentButtonDecision
    } = this.props;
    const payNowDisabled = 
      (balance <= 1  && paymentButtonDecision) ||
      (methodValue === INSTALLMENT_VALUE && isInvalidInstallment) ||
      (methodValue === SEPA_DIRECT_DEBIT_VALUE && isInvalidSepaDirectDebit) ||
      (methodValue === IDEAL_INSTALLMENT_VALUE && isInvalidIdealInstallment) ||
      (methodValue === PAY_LATER_VALUE && isInvalidPayLater);

    return (
      <div className={styles['payments__wrapper']}>
        <div className={styles['payments__content']}>
          <div className={styles['payments__header']}>
            <Translation className={styles['payments__header-head']}>
              PAYMENT_PAGE_HEADER
            </Translation>
            <Translation
              className={styles['payments__header-description']}
              onlyForUnitymedia="Vielen Dank, dass Sie sich nun um die Zahlung kümmern. Einfach
              Zahlart auswählen, und schon geht's los."
            >
              PAY_BOX_TOP
            </Translation>
          </div>
          {paymentMethods.length > 0 ? (
            <div className={styles['payments__methods']}>
              <div className={styles['payments__description']}>
                <div className={styles['payments__sum']}>
                  <Translation isHtml>CHECKOUT_BOTTOM_TOTAL</Translation>
                </div>
                <div
                  className={styles['payments__pay-now-wrapper_desktop-only']}
                >
                  <PaymentNow
                    {...{ methodName, methodValue, token }}
                    onPayNow={this.onPayNow}
                    disabled={payNowDisabled}
                    payNowLabel={(
                      translations[PAY_NOW_TEXT_KEY] || ''
                    ).toUpperCase()}
                  />
                </div>
              </div>
              <div className={styles['payments__cards']}>
                {paymentMethods.length > 1 ? (
                  <RadioGroup
                    value={methodValue}
                    options={paymentMethods}
                    onChange={this.onCardChange}
                    radioClassName={styles['payments__card-row']}
                    radioIconCheckedClassName={
                      styles['payments__card-row-icon_checked']
                    }
                  />
                ) : (
                  <div className={styles['payments__single-card']}>
                    <div className={styles['payments__single-card-label']}>
                      {paymentMethods[0].label}
                    </div>
                    <div className={styles['payments__single-card-image']}>
                      {paymentMethods[0].image}
                    </div>
                    {paymentMethods[0].content && (
                      <div className={styles['payments__single-card-content']}>
                        {paymentMethods[0].content}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className={styles['payments__pay-now-wrapper_mobile-only']}>
                <PaymentNow
                  {...{ methodName, methodValue, token }}
                  onPayNow={this.onPayNow}
                  disabled={payNowDisabled}
                  payNowLabel={(
                    translations[PAY_NOW_TEXT_KEY] || ''
                  ).toUpperCase()}
                />
              </div>
            </div>
          ) : (
            <Translation className={styles['payments__no-methods']}>
              NO_CURRENT_PAYMENT
            </Translation>
          )}
        </div>
      </div>
    );
  }
}

export default connectTo(
  ({
    auth: { token, username },
    ui: {
      payment: { hide, offlineTransferHide, methods: paymentMethods },
    },
    payment: {
      paymentUserInfo: { totalBalance, dueCurrency },
    },
    profile: { firstname, lastname, email, mobilePhone, phone },
    translations: { translations },
    decisions: {'troy.feature.payment.button.disable': paymentButtonDecision},
    ...state
  }) => ({
    token,
    username,
    paymentMethods,
    hide,
    offlineTransferHide,
    balance: totalBalance,
    currency: dueCurrency,
    firstName: firstname,
    lastName: lastname,
    email,
    mobilePhone,
    phone,
    isInvalidInstallment: isInvalid(INSTALLMENT_FORM_NAME)(state),
    isInvalidIdealInstallment: isInvalid(IDEAL_INSTALLMENT_FORM_NAME)(state),
    isInvalidPayLater: isInvalid(PAY_LATER_FORM_NAME)(state),
    isInvalidSepaDirectDebit: isInvalid(SEPA_DIRECT_DEBIT_FORM_NAME)(state),
    translations,
    paymentButtonDecision
  }),
  {
    beginPaymentSession,
    beginMollieSession,
    beginIdealInstallmentSession,
    payOffline,
    getUser,
    submit,
    sendCalculatorInfo,
    paySepaDirectDebit,
    payLater,
    setPaymentMethod,
    payMollieSofort,
  },
  Payments
);
